import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Account, AccountCreate, AccountUpdate, AccountListGetResponse, AccountListQuery } from '../../../shared/interfaces/account.interfaces';

const basePath = '/account';

@Injectable({
  providedIn: 'root',
})

export class AccountService {
  constructor(private http: HttpClient) { }

  // Get all accounts from current dealer
getAccounts(query?: AccountListQuery | undefined, currentPage?: number | undefined): Observable<AccountListGetResponse> {
  const params = new HttpParams()
    .set('rows', (query?.rows ?? 10).toString())
    .set('first', ((currentPage ?? 0) * (query?.rows ?? 10)).toString())
    .set('sort_order', (query?.sort_order ?? 1).toString())
    .set('sort_field', query?.sort_field ?? 'id')
    .set('filters', JSON.stringify(query?.filters ?? {}));
  return this.http.get<AccountListGetResponse>(basePath, { params });
}

  // Get details of a specific account
  getAccountById(id: number): Observable<Account> {
    return this.http.get<Account>(`${basePath}/${id}`);
  }

  // Creates an account for the current dealer
  createAccount(payload: AccountCreate): Observable<Account> {
    const body = {
      name: payload.name,
      number: payload.number,
      partition: payload.partition
    }
    return this.http.post<Account>(basePath, body);
  }

  // Updates an account for the current dealer. For now, can only change name and number.
  updateAccount(payload: AccountUpdate) {
    const body = {
      id: payload.id,
      name: payload.name,
      number: payload.number,
      partition: payload.partition
    };
    return this.http.put(basePath, body);
  }

    // Deletes a specific account
  deleteAccountById(id: number) {
    return this.http.delete(`${basePath}/${id}`);
  }

  // Unassigns an account from the current dealer and sends it to it's parent dealer
  unassignAccountFromDealer(id: number) {
    return this.http.put(`${basePath}/${id}`,'');
  }

}
